<template>
<span>
    <span @click.stop="print" v-loading="loading">
        <slot>
            <span class="el-icon-printer cus-button fg-primary"></span>
        </slot>
    </span>
    <!-- <el-dialog title="src" :visible.sync="visible" >
        <button @click="$refs.myPdfComponent.print()">print</button>
        <pdf ref="myPdfComponent" :src="src"></pdf>
    </el-dialog> -->
</span>

</template>

<script>
import axios from 'axios'
// import { mapGetters } from 'vuex'
// import Qs from 'qs'
// import pdf from 'vue-pdf'
// import PDFJS from 'pdfjs-dist'
import printJs from 'print-js'
// 用于打印文书
var $vue = {
    name: `PrintButton`,
    props: {
        docno: { type: Number | String, required: true },
        fromDt: ``,
        toDt: ``,
        surgeryId: ``,
        extraParams: { type: Object, default: () => {} }
    },
    // components:{pdf},
    data() {
        return {
            title: `print-frame`,
            host: this.$root.DOCSERVICE_BASE,
            src: ``,
            srcdoc: undefined,
            user: undefined,
            changed: false,
            loading: false,
            visible: false
        }
    },
    mounted() {
        // console.log(this.$root)
    },
    computed: {

    },
    methods: {
        loadDocument() {
            // this.loading  = true
            // this.$store.dispatch("LOAD_PDF_DATA",{host:this.host,params:Object.assign({
            //         docid:this.docno,
            //         from:this.$moment(this.fromDt).format("YYYYMMDDHHmm"),
            //         to:this.$moment(this.toDt).format("YYYYMMDDHHmm"),
            //         id1: this.surgeryId,
            //         id3: 1,
            //     },this.extraParams)}).then(data=>{
            //     // this.loading  = false
            //     printJs({ printable: data, type: 'pdf', base64: true })
            //     // console.log(res)
            // })
            this.$store.dispatch(`PRINT_PDF`, { host: this.$root.DOCSERVICE_BASE,
                params: Object.assign({
                    docid: this.docno,
                    from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                    to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                    id1: this.surgeryId,
                    id3: 1
                }, this.extraParams) })
        },
        loadPdf(url) {
            let req = axios.get(url)
            req.then(data => {
                // this.src = "data:application/pdf;base64," + data
                // 如果要是做预览，请自行加上前边类型字段
                printJs({ printable: data, type: `pdf`, base64: true })
                // this.$nextTick(()=>{
                //     this.$refs.myPdfComponent.print()
                // })
                // PDFJS.getDocument({data:pdfData}).then(function getPdfHelloWorld(pdf) {
                //     t.totalPage = pdf.numPages;//总页数
                //     //我是一次加载了所有页，网上一些是一页页加载的，因为我的pdf页数不多
                //     for(var i = 1;i<=t.totalPage;i++) {
                //     pdf.getPage(i).then(function getPageHelloWorld(page) {
                //         var scale = 1;//缩放倍数，1表示原始大小
                //         var viewport = page.getViewport(scale);
                //         var canvas = document.getElementById('the-canvas' + page.pageNumber);
                //         var context = canvas.getContext('2d');
                //         canvas.height = viewport.height;
                //         canvas.width = viewport.width;
                //         var renderContext = {
                //         canvasContext: context,
                //         viewport: viewport
                //         };
                //         page.render(renderContext).promise.then(function(){
                //         t.loadedPageCount ++;//加载一个+1，最后总数和totalPage一样了，表示pdf加载完了
                //         });
                //     });
                //     }
                // }).catch(function(e){
                //     alert('附件暂时无法移动端预览，请在PC端查看')
                // });
                // let vm = this;
                // PDFJS.getDocument({data:
                //         atob(data),
                //         cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/',
                //         cMapPacked: true
                //     }).then(function(pdf) {
                //     var numPages = pdf.numPages;
                //     var MAX_NUM_PAGES = 5;
                //     var ii = Math.min(MAX_NUM_PAGES, numPages);
                //     var promise = Promise.resolve();
                //     for (var i = 1; i <= ii; i++) {
                //         if(document.querySelector('[name="page='+i+'"]')){
                //             let container = document.querySelector('[name="page='+i+'"]').children[0];

                //             var viewport = vm.pdfPage.getViewport(vm.scale);
                //             document.querySelector('.pageContainer').children[0].width.baseVal.value = viewport.width;
                //             document.querySelector('.pageContainer').children[0].height.baseVal.value = viewport.height;
                //             container.style.width = viewport.width + 'px';
                //             container.style.height = viewport.height + 'px';
                //             document.querySelector('.scroll-content-info').style.width = document.querySelector('.pageContainer').getBoundingClientRect().width + 'px';
                //             return;
                //         }
                //         var anchor = document.createElement('a');
                //         anchor.setAttribute('name', 'page=' + i);
                //         anchor.setAttribute('class', 'pdfATag');
                //         anchor.setAttribute('title', 'Page ' + i);
                //         document.getElementsByClassName("scroll-content-info")[0].appendChild(anchor);

                //         // Using promise to fetch and render the next page
                //         promise = promise.then(function (pageNum, anchor) {
                //         return pdf.getPage(pageNum).then(function (page) {
                //             vm.pdfPage = page;
                //             var viewport = page.getViewport(vm.scale);
                //             var container = document.createElement('div');
                //             container.id = 'pageContainer' + pageNum;
                //             container.className = 'pageContainer';
                //             container.style.width = viewport.width + 'px';
                //             container.style.height = viewport.height + 'px';
                //             anchor.appendChild(container);

                //             return page.getOperatorList().then(function (opList) {
                //             var svgGfx = new PDFJS.SVGGraphics(page.commonObjs, page.objs);
                //             return svgGfx.getSVG(opList, viewport).then(function (svg) {
                //                 container.appendChild(svg);
                //                 document.querySelector('.scroll-content-info').style.width = document.querySelector('.pageContainer').getBoundingClientRect().width + 'px';
                //                 vm.$refs.scroll.refresh();
                //                 Util.setLoading(!1);
                //                 !vm.pdfWaterMark && Util.getUserInfo(vm.addWaterMarker);
                //             });
                //             });
                //         });
                //         }.bind(null, i, anchor))
                //     }
                // })
            }).catch(e => console.log(e))
        },
        loadUser() {
            // if(!this.currentUser){
            //     return this.myaxios.get('/api/AcisSystem/SysUser/GetCurrentUser')
            // }else{
            //     return  this.currentUser
            // }
        },
        print() {
            this.loadDocument()
        }
    }
}

export default $vue
</script>



// WEBPACK FOOTER //
// src/common/PrintButton.vue